import { Box, Dialog, DialogContent } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import ComboBox from "components/ComboBox"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import DateTimeSelect from "components/DateTimeSelect"
import SearchButton from "components/buttons/SearchButton"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import dayjs from "dayjs"
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { addIdForDataGrid } from "utils"
import { driverColNm } from "constants/driverConstant"
import { driverAttendApiNm } from "./constant"

const initFilterData = {
  ChkInTmSt: dayjs().format("YYYY-MM-DD 00:00:00"),
  ChkInTmEn: dayjs().format("YYYY-MM-DD 23:59:59"),
  DrvId: null,
}

const columns = [
  { field: "DrvCd", headerName: driverColNm.DrvCd, width: 90 },
  { field: "FullNm", headerName: "ชื่อ-สกุล", flex: 1 },
  { field: "NName", headerName: driverColNm.NName, width: 100 },
  {
    field: "ChkInTm", headerName: "เวลาเช็คอิน", width: 160,
    valueGetter: ({ value }) => value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "",
  },
]

const CheckInTimeDialog = ({ dialogOpen, setDialogOpen }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [filterData, setFilterData] = useState({ ...initFilterData })

  const getData = useCallback((filter) => {
    ax.post(driverAttendApiNm.getDriverCheckIn, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "DrvChkInId"))
      }
    })
  }, [ax])

  const setSelectDate = useCallback((start, end) => {
    setFilterData(o => ({ ...o, ChkInTmSt: start, ChkInTmEn: end }))
  }, [])

  const driverCombo = useMemo(() => msData.driverCombo, [msData.driverCombo])

  useEffect(() => {
    if (dialogOpen) {
      const filter = { ...initFilterData }
      setFilterData(filter)
      getData(filter)
    }
  }, [dialogOpen, getData])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="sm" >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="เวลาเช็คอินพนักงานขับรถ"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFC mt={2} height={550} sx={{ gap: 1 }}>
          <BoxFR>
            <Box flex={1} />
            <ComboBox options={driverCombo} label="พนักงานขับรถ" sx={{ width: 180 }}
              selectedId={filterData.DrvId}
              setSelectedId={id => setFilterData(o => ({ ...o, DrvId: id }))}
            />
            <DateTimeSelect
              sx={{ width: 180 }}
              label="เวลาเช็คอิน"
              start={filterData.ChkInTmSt}
              end={filterData.ChkInTmEn}
              setSelectDate={setSelectDate}
              getData={() => getData(filterData)}
            />
            <SearchButton onClick={() => getData(filterData)} />
          </BoxFR>
          <Box flex={1}>
            <DataGridCellExpand
              hideFooter
              rows={dataTable}
              columns={columns}
            />
          </Box>
        </BoxFC>
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(CheckInTimeDialog)
